webpackJsonp([135966999058180],{

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/1.e4553644.gif";

/***/ }),

/***/ 718:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/2.f2db1e8c.png";

/***/ }),

/***/ 1174:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ = __webpack_require__(717);
	
	var _2 = _interopRequireDefault(_);
	
	var _3 = __webpack_require__(718);
	
	var _4 = _interopRequireDefault(_3);
	
	var _reactResponsiveEmbed = __webpack_require__(26);
	
	var _reactResponsiveEmbed2 = _interopRequireDefault(_reactResponsiveEmbed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Index = function Index(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "c-content-box" },
	    _react2.default.createElement(
	      "h2",
	      null,
	      "Progetto a basso danneggiamento"
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { textAlign: 'justify', lineHeight: '2em' } },
	      _react2.default.createElement("img", { src: _2.default, style: { width: '100%', height: '100%' } }),
	      "Traducendo testualmente le parole nel PRESS Design Handbook (Pampanin et al., 2010): \"Negli ultimi dieci anni si sono osservati grandi progressi nell'ingegneria sismica con ulteriori affinamenti del performance-based design e la definizione dei corrispondenti stati limite. Seguendo le aspettative modiali e l'obiettivo ideale di una societ\xE0 con strutture dalle alte prestazioni (sismiche) e capaci di sostenere il terremoto di progetto con danno limitato o trascurabile, sono state sviluppate soluzioni simo-resistenti poco costose e altamente performanti, basate su una combinazione di materiali tradizionali e tecnologie a disposizione.\" ",
	      _react2.default.createElement("br", null),
	      " ",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "h3",
	        null,
	        "Il sistema PRESSS"
	      ),
	      "\"Una di queste \xE8 il PREcast Seismic Structural System (PRESSS), sviluppato alla University of California, San Diego (Priestley, 1991, 1996; Priestley et al. 1999). In questo sistema sono presenti elementi strutturali prefabbricati sono collegati attraverso cavi o barre post tese e non ancorate. La domanda inelastica \xE8 concentrata nelle connessioni stesse (trave-colonna, colonna-fondazione o muro-fondazione), attraverso l'apertura e chiusura di gap nelle interfacce (rocking), mentre un livello particolarmente basso di danno si concentra negli elementi strutturali, se comparato alle soluzioni gettate in opera.\" ",
	      _react2.default.createElement("br", null),
	      " ",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement("img", { src: _4.default, style: { width: '100%', height: '100%' } }),
	      _react2.default.createElement(
	        "h3",
	        null,
	        "La mia esperienza"
	      ),
	      "Ho avuto l'incredibile opportunit\xE0 di imparare a progettare questo tipo di strutture in un corso alla ROSE school di Pavia, chiamato \"Seismic Design of Low-Damage Concrete and Timber Buildings\", tenuto dal professor Stefano Pampanin. ",
	      _react2.default.createElement("br", null),
	      " ",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(_reactResponsiveEmbed2.default, { src: "https://www.youtube.com/embed/X9vDWHWCoik", allowFullScreen: true }),
	      _react2.default.createElement(_reactResponsiveEmbed2.default, { src: "https://www.youtube.com/embed/xazfxid0DAE", allowFullScreen: true })
	    )
	  );
	};
	
	exports.default = Index;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-lowdamage-it-jsx-d162255189b52bf2757e.js